<img src="/assets/images/paybevLogoGreen.png" width="162" height="67" class="p-1" />
<div nz-row class="center p-3">
      <div nz-col nzSpan="12" nzOffset="6" class="splitbox mobile-none">
            <img class="login-right-img" src="/assets/images/error-page.png" />
            <p class="p-1">It seems like something is not right, Please try reloading current page in browser. If
                  problem persist then kindly contact administrator of your organization. Alternatively you can try
                  relogin and see if it work.</p>
            <button nz-button (click)="this.location.back()" [nzType]="'primary'" style="display: unset;">Back to Last
                  Page</button>
      </div>
</div>